import React from 'react';

const TextInput = ({column, value, onChange}) => {
  const localChange = (eve) => {
    onChange({[column.name]: eve.target.value})
  }

  return (
    <div className="form-group col-md-6">
      <label htmlFor={column.name}>{column.label}</label>
      <input type="text" className="form-control" name="Name" 
        id={column.name} 
        placeholder={column.placeholder} 
        value={value} 
        onChange={localChange}></input>
    </div>
  );
};

export default TextInput;
